import React from "react";
import style from "./index.module.scss";

const CardInfo = (porps) => {
  const post = porps.post;
  const list = post.list.map((txt, i) => (
    <li
      key={i}
      className="list-item"
      data-serial={i + 1}
      dangerouslySetInnerHTML={{__html: txt}}
    />));
  return (
    <div className={style.card}>
      <h3 className={style["card-title"]}>
        <img src={post.title.url} alt={post.title.alt}/>
      </h3>
      <ol className={style.list}>
        {list}
      </ol>
      <p className="align">
        <a href={post.link} className="btn" target="_blank" rel="noopener noreferrer">READ MORE+</a>
      </p>
    </div>
  )
};

export default CardInfo;
